export default {
  login: {
    title: 'Tank Chart Service Platform',
    logIn: 'Log In',
    ver: 'Copyright (C) 2018-2025',
    oket: 'Qingdao OKet Software Co., Ltd.',
    log_fail: 'Login failure',
    username: 'User Name',
    password: 'Password',
    input: 'Please enter the user name',
    input_pass: 'Please enter password'
  },
  route: {
    首页: 'Home',
    限额管理: 'Quota Management',
    报警值管理: 'Alarm Value Management',
    账户管理: 'Account',
    组织管理: 'Organization Management',
    角色管理: 'Role Management',
    功能管理: 'Function Management',
    用户管理: 'User Management'
  },
  navbar: {
    pwd_tip: 'Your password strength is too low, please change the password as soon as possible',
    updatepPwd: 'Change Password',
    update_photo: 'Modify Avatar',
    logOut: 'Log Out',
    username: 'User Name',
    oldPwd: 'Original Password',
    newPwd: 'New Password',
    choose: 'Optional',
    confirmNewPwd: 'Confirm New Password',
    input_old_pwd: 'Please enter the original password',
    pwdDifference: 'The two passwords are inconsistent',
    inPutNewPwd: 'Please enter a new password',
    inPutPwd: 'Please enter password',
    pwdValid: 'Please enter a password of at least 6 characters',
    update_success: 'Modified successfully, please log in again',
    update_fail: 'Modification failure',
    right_image: 'Please upload the correct image format (jpge/jpg/png/gif)',
    over_image: 'If the size of the picture is larger than 1M, please select a new one',
    change_image_name: 'The image name contains special characters. Please specify the name before uploading',
    choose_image: 'Please select the profile picture to upload',
    image_success: 'Changed profile picture successfully',
    image_fail: 'Failed to change profile picture',
    menu_search: 'Menu Query',
    totalLimit: 'Total Amount',
    usedLimit: 'Used Amount',
    underwayLimit: 'Underway Amount',
    residualLimit: 'Residual Amount'
  },
  table: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    actions: 'Operation',
    edit: 'Edit',
    open: 'Enable',
    close: 'Disabled',
    edit_menu: 'Edit Menu',
    edit_function: 'Editing Function',
    add_function: 'Add Function',
    changeOpen: 'You have changed the status to --> Disabled',
    changeClose: 'You have changed the status to --> Enable',
    add_success: 'Add successfully',
    add_fail: 'Add failure',
    edit_success: 'Edit successfully',
    edit_fail: 'Editing failure',
    choose: 'Please Select',
    status: 'State',
    del: 'Delete',
    set_column: 'Set Column'
  },
  function: {
    fun: 'Function',
    write_fun_name: 'Please enter a function name',
    fun_name: 'Function Name',
    write_fun: 'Please Enter Function',
    fun_url: 'Function Url',
    write_fun_url: 'Please enter the function url',
    is_menu: 'Menu/Function',
    menu: 'Menu',
    write_menu: 'Please Enter Menu',
    menu_name: 'Menu Name',
    write_menu_name: 'Please enter a menu name',
    is_choose: 'Mandatory or Not',
    add_menu: 'Add Menu',
    edit_menu: 'Edit Menu',
    parent_menu: 'Parent Menu',
    yes: 'Yes',
    no: 'No',
    able: 'Enable',
    disable: 'Disable',
    add_function: 'Add Function',
    edit_function: 'Editing Function',
    status_change_fail: 'Status modification failure',
    choose_fun: 'Please Select Function'
  },
  button: {
    search: 'Query',
    add: 'Add',
    refresh: 'Refresh'
  },
  org: {
    org_name: 'Organization',
    org_parent_name: 'Parent Organization',
    write_org_name: 'Please enter an organization name',
    type: 'Type',
    address: 'Address',
    add_org: 'Add Organization',
    edit_org: 'Edit Organization',
    name: 'Name',
    org_name_exist: 'The organization name already exists',
    failTopOrgList: 'Failed to obtain the organization root node list. Procedure',
    choose_org: 'Please Select Organization'
  },
  role: {
    role: 'Role',
    write_role_name: 'Please Enter Role Name',
    number: 'Serial Number',
    number_enter: 'Please enter serial number',
    number_empty: 'The serial number cannot be empty',
    number_num: 'The serial number must be positive',
    owning_organization: 'Affiliated Organization',
    name: 'Name',
    organization: 'Organization',
    write: 'Please Enter',
    able: 'Enable',
    disable: 'Disable',
    add_role: 'Add Role',
    edit_role: 'Edit Rrole',
    role_del: 'The role will be deleted. Do you want to continue?',
    del_successfully: 'Deleted successfully',
    del_fail: 'Deletion failure'
  },
  user: {
    user_name: 'User',
    role_name: 'Role',
    write_user_name: 'Enter User Name',
    remakes_password: 'Reset Password',
    nickname: 'Name',
    password: 'Password',
    confirm_password: 'Confirm Password',
    email: 'Email',
    space: 'The user name cannot contain Spaces',
    less_name: 'Please enter a user name with at least 4 characters',
    exist_user_name: 'The user name already exists',
    write_nickname: 'Please Enter Your Name',
    write_password: 'Please Enter Password',
    sure_password: 'Please Confirm Password.',
    inconsistent_password: 'The two passwords are different',
    select_org: 'Please Select Organization',
    select_role: 'Please Select Role',
    write_email: 'Please enter the correct email address',
    createTime: 'CreateTime',
    updateTime: 'UpdateTime',
    loginTime: 'Last Login Time',
    add_user: 'Add User',
    search_error: 'Query Failure',
    reset: 'This operation will reset the password to ',
    is_continue: ',do you want to continue?',
    reset_successfully: 'Reset successfully',
    reset_fail: 'Reset failure',
    reset_cancle: 'Reset cancelled'
  },
  home: {
    please_enter: 'Please Enter',
    please_select: 'Please Select',
    cancle: 'Cancle',
    confirm: 'Confirm',
    save: 'Save',
    back: 'Back',
    stationName: 'Station',
    tankCode: 'Tank No.',
    oilType: 'Product',
    formStatus: 'State',
    submit: 'Submit',
    detail: 'Details',
    withdraw: 'Withdraw',
    refutation: 'Invalidate',
    download: 'Download',
    upload: 'Upload',
    basic_information: 'Basic Information',
    flowmeterNo: 'Flowmeter No.',
    tankVolume: 'Tank Capacity',
    tankDiameter: 'Tank Diameter',
    data_recording: 'Data Recording',
    order: 'Serial Number',
    manualHeight: 'Manual Height',
    levelGaugeHeight: 'Level Gauge Height',
    liquidLevelMeterTemperature: 'ATG TEMP',
    flowmeterVolume: 'Flowmeter Volume',
    flowmeterTemperature: 'Flowmeter TEMP',
    alarmValues: 'Alarm Value',
    alarmValuesDescription: 'Alarm Value Specification',
    capture: 'Call Back',
    capture_reason: 'Reason for Invalidation',
    submit_time: 'Submission Time',
    tabulation_time: 'Estimated Time',
    drag_file: 'Drag the file here, or',
    click_upload: ' Click Upload',
    limit_upload: 'Only xlsx/xls files can be uploaded, and the size does not exceed 500kb',
    limit_files: 'The current limit selects 1 file',
    select_file: 'Please Select File',
    file_upload_successfully: 'File uploaded successfully',
    file_upload_failure: 'File upload failure',
    gasoline: 'Gasoline',
    diesel_oil: 'Diesel Oil',
    to_be_submitted: 'To Be Submitted',
    pending_acceptance: 'Pending Acceptance',
    process_acceptance: 'Accepting',
    have_completed: 'Have Completed',
    delete: 'invalidated',
    called_back_reason: 'Please enter the reason for calling back',
    confirm_commit: 'Are you sure to submit this data?',
    tip: 'Notificación',
    submitted_successfully: 'Submit successfully, estimated submission time 72 hours',
    submission_failure: 'Submission failure',
    confirm_undo: 'Do you want to withdraw this data?',
    undo_successfully: 'Withdraw successfully',
    undo_failure: 'Withdraw failure',
    capture_successfully: 'Call back success',
    capture_failure: 'Call back failure',
    del: 'Reject',
    del_reason: 'Reason for Rejection',
    enter_del_reason: 'Please enter the reason for Rejection',
    del_successfully: 'Reject successfully',
    del_failure: 'Reject failure',
    list_fail: 'Data acquisition failure',
    alarm_fail: 'Failed to get the alarm list',
    customer_download: 'Volume Table Download',
    validateTankCode: 'Tank please enter a positive integer',
    validateTankVolume: 'Tank capacity please enter a positive number',
    validateTankDiameter: 'Tank diameter please enter a positive number',
    tankCodeNum: 'Tank cannot exceed 127',
    excel_download: 'Excel Format Download',
    txt_download: 'Txt Format Download'
  },
  quota: {
    quota_num: 'Limited Quantity',
    quota_enter: 'Please enter the quantity limit',
    quota_compare: 'The quantity of the quota cannot be less than the amount used',
    quota_edit: 'Modification Limit',
    quota_used: 'Used Quota',
    quota_all: 'Total Quota',
    updateTime: 'UpdateTime'
  },
  alarm: {
    del: 'Void',
    explain_zh: 'Alarm Instructions (Chinese)',
    explain_zh_enter: 'Please enter alarm instructions (Chinese)',
    explain_en: 'Alarm Instructions (English)',
    explain_en_enter: 'Please enter alarm instructions (English)',
    explain_ar: 'Alarm Instructions (Arabic)',
    explain_ar_enter: 'Please enter alarm instructions (Arabic)',
    photo: 'Photo',
    del_successfully: 'Annulment successfully',
    del_fail: 'Annulment failure',
    del_tip: 'The data will be invalidated. Do you want to continue?',
    cancle_tip: 'This operation has been canceled',
    jpg: 'Upload images only in JPG format',
    jpg_size: 'The size of the uploaded image cannot exceed 2MB'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js